export default __webpack_public_path__ + "static/media/lds-logo_hy.aeafb9f58b7e5417.svg";